import classNames from 'classnames';
import React from 'react';
import { AlertCircleMIcon } from '@alfalab/icons-glyph/AlertCircleMIcon';
import { Plate, Badge } from '@alfa-retail-react/components';

import ListView from 'app/component/list';

import 'app/logic/pages/error/PageErrors.less';

export interface PageErrorsProps {
    className?: string;
    errors: Array<string>;
}

export const PageErrors = React.forwardRef<HTMLDivElement, PageErrorsProps>(
    ({ errors, className }: PageErrorsProps, ref) => {
        return (
            <>
                <div
                    ref={ref}
                    className={classNames('validationFormErrors', className)}
                >
                    <ListView values={errors}>
                        {(element, index) => {
                            return (
                                <Plate
                                    key={index}
                                    className={'formValidationErrorPlate'}
                                    view="negative"
                                    customLeftAddons={
                                        <Badge
                                            view="icon"
                                            iconColor="negative"
                                            content={<AlertCircleMIcon />}
                                        />
                                    }
                                >
                                    {element}
                                </Plate>
                            );
                        }}
                    </ListView>
                </div>
            </>
        );
    },
);
